export class TranslationKeys {
    static readonly eterfy_landing_title = 'eterfy_title'
    static readonly eterfy_landing_description_start = 'eterfy_product_description1'
    static readonly eterfy_landing_brand = 'etermax_brand_gamification'
    static readonly eterfy_landing_description_end = 'eterfy_product_description2'
    static readonly eterfy_landing_more_info = 'more_info'
    static readonly eterfy_landing_contact_info = 'contact_information'
    static readonly eterfy_landing_contact_display_link = 'contact_display_link'
}
